import ProductSizeItem from './ProductSizeItem';

export default ProductSizeItem;
